import { render, staticRenderFns } from "./ProductsList.vue?vue&type=template&id=53e4cbb3&scoped=true"
import script from "./ProductsList.vue?vue&type=script&lang=ts"
export * from "./ProductsList.vue?vue&type=script&lang=ts"
import style0 from "./ProductsList.vue?vue&type=style&index=0&id=53e4cbb3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e4cbb3",
  null
  
)

export default component.exports